import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.Quote = class Quote extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-quote';
	}

	constructor(element) {
		super(element);
	}

	setVars() {
		this.$tweetBtn = this.$element.find('.fa-quote__twitter');
		this.$tweenAnchor = this.$tweetBtn.find('a');
	}

	initTwitter() {
		if (this.$body.hasClass('live-mode') && this.$tweetBtn) {
			this.$tweenAnchor.addClass('twitter-share-button');

			//window.twttr.widgets.load();
		}
	}

	render() {
		this.setVars();
		this.initTwitter();
	}
};



// WEBPACK FOOTER //
// ./components/quote/scripts/quote.js